"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestVerifyEmail = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useMutation_1 = require("../useMutation");
var useRequestVerifyEmail = function (_a) {
    var _b = _a.successAction, successAction = _b === void 0 ? function () { } : _b, _c = _a.errorAction, errorAction = _c === void 0 ? function (err) { } : _c;
    var _d = (0, useMutation_1.useMutation)({
        successAction: function () {
            successAction === null || successAction === void 0 ? void 0 : successAction();
        },
        errorAction: function (err) {
            var _a;
            errorAction === null || errorAction === void 0 ? void 0 : errorAction((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data);
        },
        path: keys_1.REQUEST_VERIFY_EMAIL,
    }), mutate = _d.mutate, isSubmitting = _d.isSubmitting, error = _d.error;
    return (0, react_1.useMemo)(function () { return ({
        requestVerifyEmail: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useRequestVerifyEmail = useRequestVerifyEmail;
